module.exports = __webpack_public_path__ + "static/neogov-platform-full-b2df5f5c51285b528c59c1a928277075.png";